import React from "react";

import connection from "../../../connection";
import GestaoPercurso from "./gestao";
import VisualizacaoPercurso from "./visualizacao";

import withStyles from "@material-ui/core/styles/withStyles";
import percursosStyle from "assets/jss/material-dashboard-pro-react/views/percursosStyle";

class PaginaPercurso extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      percurso: null
    };

    let id = props.id_percurso || props.location.pathname.split("/percurso/")[1];

    this.reloadInformacoesPercurso = async () => {
      let percurso = await connection.get("percurso/detalhes", {id_percurso: id});
      this.setState({percurso: percurso});
    };
  }

  componentDidMount() {
    this.reloadInformacoesPercurso();
  }

  render() {
    if (!this.state.percurso)
      return "A carregar...";
    if (this.state.percurso.pagina_gestao && !this.props.visualizacao)
      return <GestaoPercurso detalhes={this.state.percurso} reloadDetalhes={this.reloadInformacoesPercurso}/>;
    return <VisualizacaoPercurso detalhes={this.state.percurso} reloadDetalhes={this.reloadInformacoesPercurso}/>;
  }
}

export default withStyles(percursosStyle)(PaginaPercurso);
